import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="w-full pt-4 pb-28 px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center relative" data-id="element-140">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="max-w-5xl mx-auto flex flex-col items-center" data-id="element-141">
        <div className="text-brand-gold font-bold tracking-widest text-sm mb-6 uppercase flex items-center gap-2" data-id="element-142">
          <span className="text-base" style={{
          fontFamily: 'serif'
        }} data-id="element-143">
            ∞
          </span>
          Infinitamente digital
          <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-144">
            <path d="M12 2a5 5 0 0 1 4.9 4 4.5 4.5 0 0 1 2.1 3.8 4.5 4.5 0 0 1-1.5 3.4A4 4 0 0 1 16 17h-1v5h-6v-5H8a4 4 0 0 1-1.5-3.8A4.5 4.5 0 0 1 5 9.8 4.5 4.5 0 0 1 7.1 6 5 5 0 0 1 12 2z" data-id="element-145" />
            <path d="M12 2v8" data-id="element-146" />
            <path d="M8 10h8" data-id="element-147" />
          </svg>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-white mb-10 tracking-tight max-w-4xl" data-id="element-148">
          HAY DEUDAS QUE <span className="text-brand-gold" data-id="element-149">LA LEY</span> OBLIGA
          A <span className="text-brand-gold" data-id="element-150">BORRAR</span> DEL{' '}
          <span className="text-brand-gold" data-id="element-151">VERAZ</span>
        </h1>

        <div className="relative w-full max-w-xl mx-auto mb-6" data-id="element-152">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[130%] h-[130%] rounded-full blur-3xl pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(201,168,76,0.4) 0%, rgba(201,168,76,0.15) 35%, rgba(201,168,76,0.05) 55%, transparent 70%)'
        }} data-id="element-153" />
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[90%] h-[90%] rounded-full blur-2xl pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(255,245,200,0.12) 0%, rgba(201,168,76,0.08) 40%, transparent 65%)'
        }} data-id="element-154" />
          <img src="https://cdn.magicpatterns.com/uploads/qf8bMegnXerLZLetPF32ya/ChatGPT_Image_3_may_2026,_02_13_35_p.m..png" alt="Mega Pack Protocolo Salir del Veraz" className="relative z-10 w-full h-auto object-contain drop-shadow-2xl" data-id="element-155" />
        </div>

        <p className="text-xl sm:text-2xl md:text-3xl text-brand-gold font-bold mb-4" data-id="element-156"></p>

        <p className="text-base sm:text-lg md:text-xl text-gray-400 max-w-2xl mb-12" data-id="element-157">
          Si tu deuda tiene más de 5 años, tenés derechos concretos para exigir
          su eliminación.
        </p>

        <motion.a href="#pricing" initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3,
        duration: 0.5
      }} className="mb-8 inline-flex items-center gap-2 bg-green-500 text-white font-extrabold text-lg sm:text-xl px-10 py-4 rounded-full shadow-[0_0_25px_rgba(34,197,94,0.4)] hover:shadow-[0_0_35px_rgba(34,197,94,0.6)] hover:bg-green-600 hover:scale-105 transition-all duration-200 uppercase tracking-wide" data-id="element-158">
          Quiero salir del Veraz
        </motion.a>

        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 text-[10px] sm:text-xs text-gray-400 font-normal" data-id="element-159">
          <div className="border border-brand-gold/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-160">
            <span className="text-[10px]" data-id="element-161">📄</span> 100% PDF
          </div>
          <div className="border border-brand-gold/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-162">
            <span className="text-[10px]" data-id="element-163">⚡</span> Acceso inmediato
          </div>
          <div className="border border-brand-gold/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-164">
            <span className="text-[10px]" data-id="element-165">🛡️</span> Garantía 7 días
          </div>
          <div className="border border-brand-gold/15 rounded-full px-3 py-1 flex items-center gap-1.5" data-id="element-166">
            <span className="text-[10px]" data-id="element-167">💳</span> Mercado Pago
          </div>
        </div>
      </motion.div>
    </section>;
}